import OutcomeDetails from '../common/OutcomeDetails';
import screens from '../common/screens';
import { useMapElement } from '../contextProviders/MapElementProvider';
import OpenApiConfiguration from './OpenApiConfiguration';
import OpenApiDetails from './OpenApiDetails';

const OpenApiRouter = () => {
    const {
        currentScreen,
        mapElement,
        selectedOutcomeIndex,
        onSwitchScreen,
        setSelectedOutcomeIndex,
    } = useMapElement();

    switch (currentScreen) {
        case screens.openApi:
            return <OpenApiConfiguration />;

        case screens.openApiDetails:
            return <OpenApiDetails />;

        case screens.outcome: {
            const selectedOutcome = mapElement.outcomes?.[selectedOutcomeIndex ?? 0] ?? null;

            return (
                <OutcomeDetails
                    outcome={selectedOutcome}
                    onSave={() => onSwitchScreen(screens.openApi)}
                    onCancel={() => {
                        onSwitchScreen(screens.openApi);
                        setSelectedOutcomeIndex(null);
                    }}
                />
            );
        }
        default:
            return null;
    }
};

export default OpenApiRouter;
